import Logger from "./Logger";
const TAG = 'WrapperMessageDispatcher';
export default class WrapperMessageDispatcher {
    static dispatchMessage(type, payload) {
        Logger.debug(TAG, `Dispatching ${type} message to the top most frame...`);
        if (window.top) {
            window.top.postMessage({
                type: type,
                ...payload
            }, window.location.origin);
        }
    }
}
//# sourceMappingURL=WrapperMessageDispatcher.js.map